<ng-container *transloco="let t;">
    <div class="form-group mt-0 mb-2">
        <label class="col-form-label pt-0 pb-0" for="active_bcc">{{t("BCC confirmation (Template/Document - section) - BCC confirmation")}}</label>
        <div
            class="form-group d-flex justify-content-between align-items-center pt-25">
            <label
                [ngClass]="{'pointer-none': !_field.value || !canEdit, 'text-primary': _field.value && canEdit, 'text-muted': !canEdit}"
                class="pt-0 pb-0 mb-0 cursor-pointer"
                (click)="canEdit ? bccModal(activateBCCModal) : null">{{t("Manage emails text (Template/Document - section) - Manage emails")}}</label>
            <div class="custom-control custom-control-primary custom-switch ">
                <input type="checkbox" [disabled]="!canEdit" (change)="onChangeActiveBcc($event.target.checked)" class="custom-control-input"
                    id="active_bcc" [(ngModel)]="_field.value" />
                <label class="custom-control-label" for="active_bcc"></label>
            </div>
        </div>
    </div>

    <!-- Active BCC Recipient Modal Html -->
    <ng-template #activateBCCModal let-modal>
        <div class="modal-header">
            <h4 class="modal-title" id="myModalLabel1">{{t("BCC confirmation (Template/Document - section) - BCC  confirmation")}}</h4>
            <button type="button" class="close" (click)="submitBcc()" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <form [formGroup]="formGroup.get('bcc_settings')" (ngSubmit)="submitBcc()">
            <div class="modal-body" tabindex="0" ngbAutofocus>
                <div class="modal-body-wrapper">
                    <div class="row mt-25">
                        <div class="col-lg-12 col-md-12">
                            <div class="form-group">
                                <label class="col-form-label pt-0" for="Subject">{{t("BCC email Subject (Template/Document - section) - Subject")}}</label>
                                <input type="text" class="form-control" id="Subject" formControlName="subject" />
                            </div>
                        </div>
                        <div class="col-lg-12 col-md-12">
                            <div class="form-group">
                                <label class="col-form-label pt-0" for="Email">{{t("BCC Email (Template/Document - section) - Email")}}</label>
                                <input type="text" class="form-control" id="Email" formControlName="email"
                                    [ngClass]="{ 'is-invalid error': submitted && formGroup.get('bcc_settings')?.controls.email.errors }" />
                                <div *ngIf="submitted && formGroup.get('bcc_settings')?.controls.email.errors"
                                    class="invalid-feedback"
                                    [ngClass]="{ 'd-block': submitted && formGroup.get('bcc_settings')?.controls.email.errors }">
                                    <div *ngIf="formGroup.get('bcc_settings')?.controls.email.errors.invalidEmails">{{t('BCC container field error - (General section) - Invalid email')}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="submit" class="btn btn-primary" rippleEffect>
                    {{t("Template editor - Settings - BCC email popup - save button - save")}}
                </button>
            </div>
        </form>
    </ng-template>
    <!-- / Active BCC Recipient Modal Html -->
</ng-container>